export const horizontalHeaderColorStyle = function () {
  // Add custom code to execute
};